import React from 'react';
import type { AppProps } from 'next/app';
import Router from 'next/router';
import { useReportWebVitals } from 'next/web-vitals';
import { GlobalStyles } from '@spotify-internal/encore-web';
import { BrowserMetrics, WebVital } from '@spotify-internal/semantic-metrics';
import '@spotify-internal/encore-web/css/fonts.css';
import '@spotify-internal/encore-web/css/encore-text-styles.css';
import '@spotify-internal/encore-web/css/encore-dark-theme.css';
import '@spotify-internal/encore-web/css/encore-light-theme.css';
import '@spotify-internal/encore-web/css/encore-small-devices-layout-theme.css';
import '@spotify-internal/encore-web/css/encore-medium-devices-layout-theme.css';
import '@spotify-internal/encore-web/css/encore-component-styles.css';

import { sendMetric, withRouteMetrics } from '../helpers/semanticMetrics';
import { ErrorBoundaryProvider } from '../components/ErrorBoundary';

function reportVital(metric: WebVital) {
  sendMetric(
    BrowserMetrics.getWebVitalsMetric(metric, {
      route: Router.router?.route ?? 'unknown',
    }),
  );
}

const CustomApp = ({ Component, pageProps }: AppProps) => {
  useReportWebVitals(reportVital);

  return (
    <>
      <GlobalStyles />
      <ErrorBoundaryProvider>
        <Component {...pageProps} />
      </ErrorBoundaryProvider>
    </>
  );
};

export { reportVital as reportWebVitals };

export default withRouteMetrics(CustomApp);
